export const MOBILE_BREAKPOINT = '(max-width: 599.98px)';
